import { render, staticRenderFns } from "./DesignBlock.vue?vue&type=template&id=08ddd3d2"
import script from "./DesignBlock.vue?vue&type=script&lang=js"
export * from "./DesignBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports